export const title = 'Desafio Nosotras 2022'
export const description =
  '¡Tus personajes favoritos de Nosotras ahora tienen su propio juego!'
